import { Controller } from "@hotwired/stimulus"

// 検索フォームの自動送信
// 選択肢（エディション・タグ・並び順）は変えたらすぐ、キーワードは入力が止まってから送信する
export default class extends Controller {
  static values = { delay: { type: Number, default: 400 } }

  submit() {
    clearTimeout(this.timer)
    this.element.requestSubmit()
  }

  debouncedSubmit(event) {
    // 日本語入力の変換中は送らない（確定したとき compositionend で送る）
    if (event?.isComposing) return

    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
